<template>
  <a-spin :spinning="creating">
    <div class="container">
      <SeatInfo v-model:num="data.num"></SeatInfo>
      <a-button
        type="primary"
        :loading="creating"
        class="pay-button"
        @click="onPaymentClick"
      >
        {{ $t('qu-zhi-fu') }}
      </a-button>
    </div>
  </a-spin>
</template>

<script setup lang="ts" name="BuyRights">
import useOrder from './useOrder'
import SeatInfo from './seat-info.vue'

const data = reactive({ num: 1 })

const { order, creating } = useOrder(data)

const onPaymentClick = () => {
  if (order.value?.vendor_redirect_url) {
    window.location.href = order.value?.vendor_redirect_url
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 30px;
  background-color: var(--back-bg);
  border-radius: 12px;
}
.pay-button {
  display: block;
  width: 280px;
  height: 40px;
  margin: 58px auto 0;
}
</style>
